(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Force sort accordion open inside drawer */
  const observer = new MutationObserver(() => {
    const drawer = document.querySelector('.facets--drawer');
    if (!drawer) return;
    const sortDetails = drawer.querySelector('.sorting-filter .facets__panel');
    if (sortDetails && !sortDetails.open) {
      sortDetails.open = true;
    }
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Force sort accordion open inside drawer */
  const observer = new MutationObserver(() => {
    const drawer = document.querySelector('.facets--drawer');
    if (!drawer) return;
    const sortDetails = drawer.querySelector('.sorting-filter .facets__panel');
    if (sortDetails && !sortDetails.open) {
      sortDetails.open = true;
    }
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });

  } catch(e) { console.error(e); }
})();
})();
